import React, { FC } from 'react';
import styled from 'styled-components';
import { textColor, THEME_RED, THEME_SECONDARY } from '../../../styles/basics/colors';
import { flex } from '../../../styles/utilities/flex';
import { HelpTooltip } from '../../../shared/common/HelpTooltip';

const StTitle = styled.div`
    ${flex('row')};
    ${textColor(THEME_SECONDARY)};
    font-size: 13px;
    min-height: 15px;
    line-height: 1;
    align-items: center;
`;

const StMandatoryHint = styled.span`
    ${textColor(THEME_RED)};
    margin-left: 1px;
`;

const StTooltip = styled(HelpTooltip)`
    margin-left: 5px;
`;

interface Props {
    text: string;
    editable: boolean;
    className?: string;
    tooltipText?: string;
    mandatory?: boolean;
}

const LCFormFieldTitle: FC<Props> = props => {
    return (
        <StTitle className={props.className}>
            {props.text}
            {props.editable && props.mandatory ? <StMandatoryHint>*</StMandatoryHint> : null}
            {props.editable && props.tooltipText ? <StTooltip text={props.tooltipText} /> : null}
        </StTitle>
    );
};

export default LCFormFieldTitle;
